import { createContext, useContext } from "react";

/**
 * Context neutre du FormBuilderRender.
 * Il expose uniquement des capacités optionnelles,
 * injectées par le contexte métier (formalités, autre).
 */
export const FormBuilderRenderContext = createContext({
  openDocument: null,
});

/**
 * Hook de consommation côté FormBuilder
 */
export const useFormBuilderRenderContext = () =>
  useContext(FormBuilderRenderContext);
